import { AccountConfigModule } from '@abpdz/ng.account/config';
import { CoreModule, registerLocale } from '@abpdz/ng.core';
import { IdentityConfigModule } from '@abpdz/ng.identity/config';
import { ThemeBasicModule } from '@abpdz/ng.theme.basic';
import { ThemeSharedModule } from '@abpdz/ng.theme.shared';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ThemeFuseModule } from '@abpdz/ng.theme.fuse';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_ROUTE_PROVIDER } from './route.provider';
import { SharedModule } from './shared/shared.module';
import { EnrolmentConfigModule } from '@module/enrolment/config';
import { BillingConfigModule } from '@module/billing/config';
import { EzynessAdminConfigModule } from '@module/ezyness-admin/config';
import { HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { appMetaReducers } from './reducers';
import { AbpDzAuditConfigModule } from '@abpdz/ng.audit/config';
import '@angular/common/locales/global/fr';

import {
  StoreRouterConnectingModule,
  RouterState,
  routerReducer,
} from '@ngrx/router-store';
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ThemeFuseModule,
    HttpClientModule,
    AppRoutingModule,
    StoreModule.forRoot(
      { router: routerReducer },
      {
        metaReducers: appMetaReducers,
        runtimeChecks: {
          strictStateSerializability: true,
          strictActionSerializability: false,
          strictActionImmutability: true,
          strictStateImmutability: true,
          strictActionTypeUniqueness: true,
          strictActionWithinNgZone: true,
        },
      }
    ),
    CoreModule.forRoot({
      environment,
      registerLocaleFn: registerLocale(),
      sendNullsAsQueryParam: false,
      skipGetAppConfiguration: false,
    }),
    ThemeSharedModule.forRoot(),
    ThemeBasicModule.forRoot(),
    IdentityConfigModule.forRoot(),
    SharedModule.forRoot(),
    AccountConfigModule.forRoot(),
    EnrolmentConfigModule.forRoot(),
    BillingConfigModule.forRoot(),
    EzynessAdminConfigModule.forRoot(),

    AbpDzAuditConfigModule.forRoot(),
  ],
  providers: [APP_ROUTE_PROVIDER, { provide: LOCALE_ID, useValue: 'fr' }],
  bootstrap: [AppComponent],
})
export class AppModule {}
